<template>
  <div class="videos-step">
    <el-card shadow="never">
      <template #header>
        <div class="card-header">
          <span>视频生成</span>
          <el-button type="primary" @click="generateVideos" :loading="generating">
            <el-icon><VideoCamera /></el-icon>
            生成视频片段
          </el-button>
        </div>
      </template>

      <el-empty v-if="!videosData" description="暂无视频数据">
        <p>点击"生成视频片段"按钮，将图片转换为动态视频</p>
      </el-empty>

      <div v-else class="videos-content">
        <el-row :gutter="20">
          <el-col v-for="(video, index) in videosData" :key="index" :xs="24" :sm="12" :md="8">
            <el-card class="video-card" shadow="hover">
              <div class="video-preview">
                <video v-if="video.url" :src="video.url" controls />
                <div v-else class="video-placeholder">
                  <el-icon><VideoCamera /></el-icon>
                  <p>等待生成</p>
                </div>
              </div>
              <div class="video-info">
                <p class="scene-name">场景 {{ video.scene_number }}</p>
                <p class="video-status">
                  <el-tag :type="video.url ? 'success' : 'info'" size="small">
                    {{ video.url ? '已生成' : '待生成' }}
                  </el-tag>
                </p>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <div class="actions">
          <el-button type="success" @click="confirmVideos">
            <el-icon><Check /></el-icon>
            确认视频并继续
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  projectId: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['step-complete', 'step-save'])

const videosData = ref(null)
const generating = ref(false)

const generateVideos = async () => {
  generating.value = true
  try {
    // 调用API生成视频
    videosData.value = [
      { scene_number: 1, url: '' },
      { scene_number: 2, url: '' },
      { scene_number: 3, url: '' }
    ]
    ElMessage.success('视频生成成功')
  } catch (error) {
    ElMessage.error('视频生成失败')
  } finally {
    generating.value = false
  }
}

const confirmVideos = () => {
  emit('step-complete')
}
</script>

<style scoped lang="scss">
.videos-step {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.video-card {
  margin-bottom: 20px;
  
  .video-preview {
    height: 180px;
    background: #000;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    
    .video-placeholder {
      text-align: center;
      color: #909399;
      
      .el-icon {
        font-size: 32px;
        margin-bottom: 8px;
      }
    }
  }
  
  .video-info {
    margin-top: 12px;
    text-align: center;
    
    .scene-name {
      font-weight: 500;
      margin-bottom: 4px;
    }
  }
}

.actions {
  margin-top: 24px;
  text-align: center;
}
</style>
